// src/hooks/useTokensCatalog.ts
import { useQuery } from "@tanstack/react-query";
import { fetchTokens } from "@/services/tokens";
import type { TokenMetadata } from "@/types/tokens";

export const tokenQueryKeys = {
  all: ["tokens"] as const,
  list: () => [...tokenQueryKeys.all, "list"] as const,
} as const;

export function useTokensCatalog() {
  return useQuery<TokenMetadata[]>({
    queryKey: tokenQueryKeys.list(),
    queryFn: ({ signal }) => fetchTokens(signal),
    staleTime: 5 * 60 * 1000,
  });
}


